module.exports = __webpack_public_path__ + "img/8.f02989d4.png";